import script from "./CheckboxFacade.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxFacade.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxFacade.vue?vue&type=style&index=0&id=c7d69b7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d69b7e"]])

export default __exports__